import { useState } from "react";
import { registerUser } from "../api/api";

function Register() {
  const [form, setForm] = useState({});

  const handleRegister = async () => {
    await registerUser(form);
    alert("Registered Successfully");
  };

  return (
    <div className="form">
      <h2>Register</h2>

      <input placeholder="Name"
        onChange={(e)=>setForm({...form,name:e.target.value})} />

      <input placeholder="Email"
        onChange={(e)=>setForm({...form,email:e.target.value})} />

      <input type="password" placeholder="Password"
        onChange={(e)=>setForm({...form,password:e.target.value})} />

      <button onClick={handleRegister}>Register</button>
    </div>
  );
}

export default Register;